import $ from 'jquery';
import 'slick-carousel/slick/slick.js';
import { dataLayerEventExist } from '../site/helpers';

class CapabilitiesSlider {
  constructor(selector) {
    this.container = $(selector).find('.filter-slides');
    this.buttons = $(selector).find('.filter-button');

    this._initializeSlider();
    this._setListeners();
  }

  _initializeSlider() {
    // Initialize slick slider
    this.container.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      adaptiveHeight: true,
      swipe: true
    });

    // Update active button on slide change
    this.container.on('afterChange', (event, slick, currentSlide) => {
      this._updateActiveButton(currentSlide);
    });
  }

  _setListeners() {
    this.buttons.on('click', (event) => this._handleButtonClick(event));
  }

  _handleButtonClick(event) {
    const target = $(event.currentTarget);
    const filterIndex = this.buttons.index(target);
    const buttonText = event.target.innerText;

    // Update slider to the corresponding slide
    this.container.slick('slickGoTo', filterIndex);

    // Update active button
    this.buttons.removeClass('active');
    target.addClass('active');

    // GTM
    const isWorkshopsPage = window.location.pathname === '/workshops/';
    const gtmEvent = isWorkshopsPage ? 'workshopCategoryClick' : 'capabilityCategoryClick';
    if (!dataLayerEventExist(gtmEvent, buttonText)) {
      window.dataLayer.push({
        event: gtmEvent,
        eventLabel: buttonText
      });
    }
  }

  _updateActiveButton(index) {
    this.buttons.removeClass('active');
    this.buttons.eq(index).addClass('active');
  }
}

const capabilitiesSlider = (selector) => {
  $(selector).each((index, element) => {
    new CapabilitiesSlider(element);
  });
};

export default capabilitiesSlider;
